<template>
  <div class="container">
    <el-dialog
      class="default-dialog"
      title="新建项目报告"
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content-max" v-loading="loading">
        <div class="content-top">
          <span style="color:red;margin-right:5px">*</span>
          项目名称：
          <el-input v-model="reportName" placeholder="请输入项目名称" size="small" style="width:350px" clearable></el-input>
        </div>
        <div class="content-box">
          <p class="box-title">基本情况</p>
          <div class="box-top">
            <span style="color:red;margin-right:5px">*</span>
            <el-input
              v-model="form.customerName"
              @focus="isNextStu = true"
              @blur="customerBlur"
              @clear="clearCustomerName"
              placeholder="请输入公司名称"
              size="small"
              style="width:350px"
              clearable
            ></el-input>
          </div>
          <div class="box-wrap">
            <div class="box-item">
              <span class="box-item-left">法人：</span>
              <span class="box-item-right">{{ form.corporate }}</span>
            </div>
            <div class="box-item">
              <span class="box-item-left">纳税资格：</span>
              <span
                class="box-item-right"
              >{{ disposeTsxEligibility(form.taxEligibility) || (form.customerName ? '未知' : '') }}</span>
            </div>
            <div class="box-item">
              <span class="box-item-left">地址：</span>
              <span class="box-item-right">{{ form.address }}</span>
            </div>
            <div class="box-item">
              <span class="box-item-left">经营范围：</span>
              <span class="box-item-right">{{ form.natureOfBusiness }}</span>
            </div>
          </div>
          <p class="box-title">财税分析</p>
          <div class="box-top">
            <span style="color:red;margin-right:5px">*</span>
            <AccountingPeriod ref="AccountingPeriod" @defaultTime="defaultTime" :isEmpty="true" :isEndTimeStu="true" />
          </div>
          <div class="box-item">
            <span class="box-item-left">营业收入：</span>
            <span class="box-item-right">
               {{ income || 0 }}
            </span>
          </div>
          <div class="box-item">
            <span class="box-item-left">税种税金：</span>
            <span class="box-item-right">{{ taxation || 0 }}</span>
          </div>
        </div>
        <div class="content-bottom">
          备注：
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 5}"
            placeholder="请输入"
            v-model="form.remarks"
            size="small"
            maxlength="200"
            show-word-limit
          ></el-input>
        </div>
      </div>

      <div slot="footer" align="center">
        <el-button size="small" style="width: 100px;" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" style="width: 100px;background: #269D7B;color: #fff;" :loading="isNextStu" @click="handleNext">下一步</el-button>
      </div>
    </el-dialog>
    <!-- 项目报告编辑 -->
    <ProjectReportEditor ref="ProjectReportEditor" @save="handleSave" />
  </div>
</template>

<script>
import AccountingPeriod from "@/components/dialog/accountingPeriod"
import ProjectReportEditor from "@/components/dialog/ProjectReportEditor"
import Moneys from '@/components/moneys'
import { currencys,filterMoeny } from "@/assets/utils/currencyFormat.js"
import { findRiskReportBasicInformation, findRiskReportIncome, findRiskReportTax, saveCustomerRiskReport } from "@/api"
export default {
  components: { AccountingPeriod, ProjectReportEditor, Moneys },
  props: {},
  created() {},
  data() {
    return {
      isNextStu: false,
      loading: false,
      input: "",
      dialogVisible: false,
      reportName: "",
      form: {
        customerName: "",
        remarks: ""
      },
      income: "",
      taxation: "",
      startYearPeriods: "",
      endYearPeriods: "",
      initCustomerName: "",
      yearPeriodsStart: '',
      yearPeriodsEnd: '',
    }
  },
  methods: {
    handleOpen() {
      this.dialogVisible = true
      this.clearStorage()
      this.$nextTick(() => {
        this.$refs.AccountingPeriod.clearTimeRange()
      })
      this.findCompanyInfo()
    },
    // 清空this缓存
    clearStorage() {
      this.startYearPeriods = ''
      this.endYearPeriods = ''
      this.reportName = "",
      this.form = {
        customerName: "",
        remarks: "",
      }
      this.income = ''
      this.taxation = ''
    },
    handleNext() {
      if (!this.reportName) {
        return this.$message.error("请输入项目名称")
      }
      if (!this.form.customerName) {
        return this.$message.error("请输入公司名称")
      }
      if (!this.startYearPeriods || !this.endYearPeriods) {
        return this.$message.error("请选择财税分析时间")
      }
      this.$refs.ProjectReportEditor.handleOpen(this.reportName,this.configTemplate())
    },
    // 查询企业信息
    async findCompanyInfo(type = 1) {
      try {
        this.loading = true
        const { data } = await findRiskReportBasicInformation({
          cid: JSON.parse(sessionStorage.getItem("cid")),
          type,
          name: this.form.customerName
        })
        if (data.code == 1) {
          this.form = {...data.data}
          // 记录初次进来客户名称
          this.initCustomerName = data.data.customerName
        }
      } catch (error) {
        this.loading = false
      }
      this.loading = false
    },
    // 查询财务信息-营业收入
    async findAnalysisInfo() {
      try {
        this.loading = true
        const params = {
          cid: JSON.parse(sessionStorage.getItem("cid")),
          start: this.startYearPeriods,
          end: this.endYearPeriods
        }
        const data1 = await findRiskReportIncome(params)
        const data2 = await findRiskReportTax(params)
        if (data1.data.code == 1) {
          this.income = this.disposeAmount(data1.data.data.income)
        }
        if (data2.data.code == 1) {
          this.taxation = data2.data.data ? data2.data.data.map(x => x.name + this.disposeAmount(x.money)).join("、") : ""
        }
      } catch (error) {
        this.loading = false
      }
      this.loading = false
    },
    // 处理金额小于万
    disposeLessThousand(val) {
      let n = String(val)
      return currencys(n,'',n.split('.')[1] ? (n.split('.')[1].length > 2 ? 2 : n.split('.')[1].length) : 0) + '元'
    },
    // 处理万和小于万的值
    disposeAmount(ret) {
      if(!ret) { return 0 }
      let arr = String(Number(ret)).split('.')
      ret = arr[0].length > 5 ? filterMoeny(ret) + '元' : this.disposeLessThousand(Number(ret))
      return ret
    },
    clearCustomerName() {
      this.form.taxEligibility = ''
      this.form.address = ''
      this.form.natureOfBusiness = ''
      this.form.corporate = ''
    },
    handleSave(projectPlanPdfHtml) {
      console.log(projectPlanPdfHtml)
      this.form.projectPlanPdfHtml = projectPlanPdfHtml.value;
      this.form.htmlContent = projectPlanPdfHtml.html;
      this.escalationProject()
    },
    // 上报项目
    async escalationProject() {
      try {
        this.loading = true
        this.form.reportName = this.reportName
        const { data } = await saveCustomerRiskReport(this.form)
        if (data.code == 1) {
          this.$message.success(data.msg)
          this.dialogVisible = false
          // 删除当前账套的临时保存任务
          localStorage.removeItem(JSON.parse(sessionStorage.getItem('cid')))
        }
      } catch (error) {
        this.loading = false
      }
      this.loading = false
    },
    // 公司输入框失去焦点重新请求数据
    customerBlur() {
      if(this.form.customerName == this.initCustomerName) {
        this.isNextStu = false
        return
      }
      let type = this.form.customerName ? 2 : 1
      this.findCompanyInfo(type)
      this.isNextStu = false
    },
    // 接收会计期间数据
    defaultTime(data) {
      if (!data.yearPeriodsStart || !data.yearPeriodsEnd) {
        return
      }
      this.yearPeriodsStart = data.yearPeriodsStart
      this.yearPeriodsEnd = data.yearPeriodsEnd
      ;(this.startYearPeriods = this.$util.formatDate.format(data.yearPeriodsStart, "yyyyMM")),
        (this.endYearPeriods = this.$util.formatDate.format(data.yearPeriodsEnd, "yyyyMM"))
      this.findAnalysisInfo()
    },
    // 转换纳税资格
    disposeTsxEligibility(type) {
      return type == 1? '小规模' : type == 2?'一般纳税人': type == 3?'个体户':''
    },
    // 配置富文本初始模板
    configTemplate() {
      const startDate = this.$util.formatDate.format(this.yearPeriodsStart , 'yyyy年MM月')
      const endDate = this.$util.formatDate.format(this.yearPeriodsEnd , 'yyyy年MM月')
      // 解析参数
      const { customerName,address,natureOfBusiness,taxEligibility,corporate } = this.form
      const str = `
      <div data-v-6626ae90="" data-element="root" class="am-engine">
        <h1 style="text-align: center;" data-id="hs28u7csg-4g5hwitmosu00" id="hs28u7csg-4g5hwitmosu00">${this.reportName}项目方案</h1>
        <h3 data-id="h4kgw8yp6-96d2rjab9cg" id="h4kgw8yp6-96d2rjab9cg">一、基本情况</h3>
        <p data-id="p1dr9j7ls-i2956yn5sog0"><span style="color: rgb(89, 89, 89);">公司名称：${customerName || '..........'}</span></p>
        <p data-id="p99zltr6o-6lmsdpvbjus00"><span style="color: rgb(89, 89, 89);">地址：${address || '..........'}</span></p>
        <p data-id="p99zltr6o-1kgdgtgx5heo0"><span style="color: rgb(89, 89, 89);">纳税资格：${this.disposeTsxEligibility(taxEligibility) || '..........'}</span></p>
        <p data-id="p99zltr6o-ebju04yotn400"><span style="color: rgb(89, 89, 89);">法定代表人：${corporate || '..........'}</span></p>
        <p data-id="p99zltr6o-g2u6bltxrj400"><span style="color: rgb(89, 89, 89);">经营范围：${natureOfBusiness || '..........'}</span></p>
        <p data-id="p1dr9j7ls-j073a367zog00"><br></p>
        <h3 data-id="h4kgw8yp6-gswaortdlfs00" id="h4kgw8yp6-gswaortdlfs00">二、财税分析</h3>
        <p data-id="p1dr9j7ls-27dfbwy56v0g0">
          ${startDate + '-' +endDate} 营业收入
          <span style="color: rgb(250, 84, 28);">${this.income}</span>，
          <span style="color: rgb(250, 84, 28);">${this.taxation ? this.taxation + '。' : ''}</span>
          具体描述..........
        </p>
        <p data-id="p1dr9j7ls-5g3dhcw0zp800"><br></p>
        <h3 data-id="h4kgw8yp6-fov678t9dls00" id="h4kgw8yp6-fov678t9dls00">三、建议方案</h3>
        <p data-id="p1dr9j7ls-88zvfe9yjjs00">
          目前问题：
          <span style="color: rgb(250, 84, 28);">对该公司进行分析发现，具体描述..........</span>
        </p>
        <p data-id="p99zltr6o-7haoqce2pfc00" style="text-indent: 2em;">我们可以在保证公司业务真实、税收合法的前提下，对公司的架构进行调整优化，其主要目的是具体描述..........</p>
        <p style="text-indent: 2em;" data-id="p99zltr6o-jzt6yyzn58g00"><br></p>
        <p data-id="p99zltr6o-4ky0iqjeu7s00">方案一：具体描述..........</p>
        <p data-id="p1dr9j7ls-6i8k0w1k81w00"><br></p>
        <p data-id="p99zltr6o-dzd1f915vy800">优点：具体描述..........</p>
        <p data-id="p1dr9j7ls-5yqqcw70gco00"><br></p>
        <p data-id="p99zltr6o-eknytu84j6o00">缺点：具体描述..........</p>
        <p data-id="p99zltr6o-h47rgm9bdwg00"><br></p>
        <h3 data-id="h4kgw8yp6-4dxdhyjgfgy00" id="h4kgw8yp6-4dxdhyjgfgy00">四、综合测算</h3>
        <p data-id="p1dr9j7ls-j7csgkgumts00">经测算，<span style="color: #fa541c;">具体描述..........</span></p>
        <p data-id="p1dr9j7ls-eybb3kz85n400"><br></p><p data-id="p99zltr6o-bq4y1rl6x0o00">综合以上，具体描述..........</p>
        <p data-id="p1dr9j7ls-46naz1i67l400"><br></p>
        <h3 data-id="h4kgw8yp6-w9s2uppcncw0" id="h4kgw8yp6-w9s2uppcncw0">五、附件</h3>
        <p data-id="p1dr9j7ls-bzqoe3el16w00">具体描述..........</p><p data-id="p1dr9j7ls-r2m6qxjarzk0"><br></p>
      </div>
      `
      return str
    }
  }
}
</script>

<style lang='less' scoped>
.content-max {
  .content-top {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  .content-box {
    padding: 15px;
    background-color: #f9f9f9;
    .box-title {
      color: #333333;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .box-top {
      display: flex;
      margin-bottom: 15px;
    }
    .box-wrap {
      padding: 15px;
      background-color: #fff;
      margin-bottom: 20px;
    }
    .box-item {
      display: flex;
      margin-bottom: 10px;
      &-left {
        width: 75px;
        display: inline-block;
        text-align: right;
        white-space: nowrap;
        color: #999999;
      }
      &-right {
        width: calc(100% - 80px);
        display: inline-block;
        color: #666666;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .content-bottom {
    margin-top: 20px;
    display: flex;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/ProjectReport.vue